import React from 'react'
import { Route, Routes } from 'react-router-dom'

import { InvitationsListView } from './InvitationsListView'

export const InvitationsView: React.FC = () => {
  return (
    <Routes>
      <Route path="/admin/invitations" element={<InvitationsListView />} />
      {/* <Redirect to="/admin/invitations" /> */}
    </Routes>
  )
}
